<template>
  <main class="">
    <section class="control-page-common driver_reward">
      <div class="console-title console-title-border title-flex">
        <div class="title-default">司机补款奖励</div>
        <el-common-video
          href="https://mgate.didistatic.com/static/mgate/do1_ysuzlMDZCCCrry2v6bcB"
        ></el-common-video>
      </div>
      <el-card class="box-card driver_reward__content">
        <div class="driver_reward__content__left">
          <p class="driver_reward__content__left__enable__money">
            可用余额(元)
          </p>
          <p class="driver_reward__content__left__money number-medium">
            {{ draw }}
          </p>
          <el-button
            type="primary"
            @click="toDriverGrant"
            :disabled="draw <= 0"
            class="medium-small supplement-btn"
            >发 放</el-button
          >
        </div>
        <div class="driver_reward__content__right">
          <p>
            <span>奖励：每月给予达标司机一定的奖励或补贴到司机钱包余额；</span>
            <span
              >退款：若司机线下补缴租金超过当月应收租金，则将返还多余金额到司机钱包余额；</span
            >
          </p>
          <p style="color:#858b9c">
            *您发起补款奖励后，对应的钱款将于当日实时到账司机钱包余额；
          </p>
        </div>
      </el-card>
      <el-result-list></el-result-list>
    </section>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import ResultList from './driver-supplement-reward-tabel.vue'
import commonVideo from '../../components/console-common/common-video.vue'
import { toYuan } from '../../utils/unit-conversion'
export default {
  components: {
    'el-result-list': ResultList,
    'el-common-video': commonVideo,
  },
  computed: {
    ...mapState('balance', {
      balanceData: 'balanceData',
    }),
    draw() {
      const { draw } = this.balanceData
      return draw !== undefined ? toYuan(draw).toFixed(2) : ''
    },
  },
  created() {
    this.$store.dispatch('balance/GET_BALANCE')
  },
  data() {
    return {
      // slotDate: [],
      otherParam: {},
      exportConfig: {
        fileName: '司机补款奖励列表',
        keyUrl: '/proxy/api/reward/export',
        statusUrl: '/proxy/api/getFileUrl',
        statusKeys: 'fileGiftKey',
      },
    }
  },
  methods: {
    toDriverGrant() {
      this.$router.push({ name: 'driverGrant' })
    },
  },
}
</script>

<style lang="stylus">
@import '../../assets/css/common-color.styl'
.driver_reward
  .driver_reward__content
    margin-bottom 40px
  &__content
    margin-top 20px
    box-sizing border-box
    .el-card__body
      display flex
    &__left
      padding-right 32px
      border-right 1px solid #DCDFE6
      &__enable__money
        color gray03
        font-size 12px
      &__money
        color #FC9153
        font-size 22px
        margin 6px 0 16px 0
    &__right
      padding-left 32px
      font-size 12px
      color gray03
      p:nth-child(1)
        display flex
        flex-direction column
        justify-content center
        margin-bottom 20px
  .supplement-btn
    padding 8px 31px
  .el-card
    border-color #f0f0f0
  .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover
    box-shadow 0 2px 4px 1px rgba(226, 228, 234, 0.29)
</style>
